module.exports = __webpack_public_path__ + "./FergusPhoto_0a1591a51980808faf1f7165e332f47e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/FergusPhoto.png
// module id = 477
// module chunks = 0